import { render, staticRenderFns } from "./MenuItemSub.vue?vue&type=template&id=74ca363c&scoped=true&"
import script from "./MenuItemSub.vue?vue&type=script&lang=ts&"
export * from "./MenuItemSub.vue?vue&type=script&lang=ts&"
import style0 from "./MenuItemSub.vue?vue&type=style&index=0&id=74ca363c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca363c",
  null
  
)

export default component.exports